'use client';

import { useState } from 'react';
import { SearchLine as BaseSearchLine } from '@org/ui';
import { Input } from '@/components/ui/input';
import { useLanguage } from '@/lib/config/useLanguage';
import { buildLanguagePath } from '@/lib/config/utils';

export default function SearchLine() {
    const [query, setQuery] = useState('');
    const { tf, langCode } = useLanguage();

    // Функция для построения пути с учетом языка
    const buildPath = (path) => {
        return buildLanguagePath(langCode, path);
    };

    const translations = {
        placeholder: tf('placeholders', 'search'),
    };

    return (
        <BaseSearchLine
            value={query}
            onChange={setQuery}
            translations={translations}
            buildPath={buildPath}
            InputComponent={Input}
        />
    );
}
